import styled from "styled-components";
import theme from "../common/theme";

const Sidebar = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 15%;
    min-width: 350px;
    padding: 1rem;
    background: #fff;
    gap: 1rem;
    // max-height: 100vh;
    overflow-y: auto;
    border-right: 1px solid ${theme.palette.border};
`

export default Sidebar;